import type { ProductTaxonomyRenameDefinition } from '../types';

export const broadcastsRename = {
  terms: {
    broadcasts: {
      current: {
        singular: 'newsletter',
        indefiniteSingular: 'a newsletter',
        plural: 'newsletters',
        titleSingular: 'Newsletter',
        titlePlural: 'Newsletters',
      },
      future: {
        singular: 'one-time send',
        indefiniteSingular: 'a one-time send',
        plural: 'one-time sends',
        titleSingular: 'One-time send',
        titlePlural: 'One-time sends',
      },
    },
  },
  copy: {
    'nav.broadcasts.newsletters': {
      term: 'broadcasts.titlePlural',
    },
  },
  routes: {
    'broadcasts.oneTimeSends': {
      current: '/workspaces/:workspaceId/journeys/broadcasts/newsletters',
      future: '/workspaces/:workspaceId/journeys/broadcasts/one_time_sends',
    },
  },
} as const satisfies ProductTaxonomyRenameDefinition;
